import { render, staticRenderFns } from "./PsnTaxBfNew.vue?vue&type=template&id=3b1154b0"
import script from "./PsnTaxBfNew.vue?vue&type=script&lang=js"
export * from "./PsnTaxBfNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports